import { render } from "./ProfileTab.vue?vue&type=template&id=9718a634&scoped=true"
import script from "./ProfileTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileTab.vue?vue&type=script&setup=true&lang=js"

import "./ProfileTab.vue?vue&type=style&index=0&id=9718a634&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9718a634"],['__file',"src/views/ProfileTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9718a634"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9718a634', __exports__)) {
    api.reload('9718a634', __exports__)
  }
  
  module.hot.accept("./ProfileTab.vue?vue&type=template&id=9718a634&scoped=true", () => {
    api.rerender('9718a634', render)
  })

}


export default __exports__